import { Navigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import {
  canAccessDepartments,
  canAccessPlatformConfig,
  canViewSla,
  getDefaultPlatformConfigPath,
} from '../utils/permissions';

type Props = {
  check: (user: NonNullable<ReturnType<typeof useAuth>['user']>) => boolean;
  children: React.ReactNode;
};

/** Inline permission gate for platform-config tab pages (avoids nested pathless layout routes). */
export function PlatformConfigTabGuard({ check, children }: Props) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading…</div>;
  }

  if (!user || !check(user)) {
    return <Navigate to={user ? getDefaultPlatformConfigPath(user) : '/login'} replace />;
  }

  return <>{children}</>;
}

export function PlatformConfigMasterGuard({ children }: { children: React.ReactNode }) {
  return (
    <PlatformConfigTabGuard check={canAccessPlatformConfig}>{children}</PlatformConfigTabGuard>
  );
}

export function DepartmentsTabGuard({ children }: { children: React.ReactNode }) {
  return (
    <PlatformConfigTabGuard check={canAccessDepartments}>{children}</PlatformConfigTabGuard>
  );
}

export function SlaTabGuard({ children }: { children: React.ReactNode }) {
  return <PlatformConfigTabGuard check={canViewSla}>{children}</PlatformConfigTabGuard>;
}
